import { Card, Col, Row } from 'reactstrap';
import Parametros from 'models/Parametros';
import Subtitle from 'views/components/Subtitle';
import { TextField } from '@material-ui/core';
import { arredondaDecimais } from 'utils/arredondaDecimais';
import { iAcessoPrograma, iPropostaDados } from '../..';

export default function VariaveisComerciais({
  propostaVersao,
  isModoSimulacao,
  onChange,
  acessoPrograma,
  parametros,
}: {
  propostaVersao: iPropostaDados;
  isModoSimulacao: boolean;
  onChange: (a: iPropostaDados) => void;
  acessoPrograma: iAcessoPrograma;
  parametros?: Parametros;
}): JSX.Element {
  async function changeValue(campo: string, valor: number) {
    onChange({
      ...propostaVersao,
      valores: {
        ...propostaVersao.valores,
        [campo]: valor,
      },
    });
  }

  return (
    <Card className="shadow p-3">
      <Subtitle name="Variáveis comerciais" />
      <Row className="px-2">
        <Col className="mb-2" md="3">
          <TextField
            label="Licenciamento (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualLicenciamento ?? 0}
            onChange={e =>
              changeValue('percentualLicenciamento', Number(e.target.value))
            }
            disabled={!isModoSimulacao}
          />
        </Col>
        <Col className="mb-2" md="3">
          <TextField
            label="Topografia (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualTopografia ?? 0}
            onChange={e =>
              changeValue('percentualTopografia', Number(e.target.value))
            }
            disabled={!isModoSimulacao}
          />
        </Col>

        <Col className="mb-2" md="3">
          <TextField
            label="Frete (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualFrete ?? 0}
            onChange={e =>
              changeValue('percentualFrete', Number(e.target.value))
            }
            disabled={!isModoSimulacao}
          />
        </Col>

        <Col className="mb-2" md="3">
          <TextField
            label="Assistência Técnica (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualAssistenciaTecnica ?? 0}
            onChange={e =>
              changeValue(
                'percentualAssistenciaTecnica',
                Number(e.target.value),
              )
            }
            disabled={
              !isModoSimulacao ||
              acessoPrograma.variaveisComerciais.acessoLimitado
            }
          />
        </Col>

        <Col className="mb-2" md="3">
          <TextField
            label="Taxa Flat (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualTaxaFlat ?? 0}
            onChange={e =>
              changeValue('percentualTaxaFlat', Number(e.target.value))
            }
            disabled={
              !isModoSimulacao || acessoPrograma.taxaFlat.acessoLimitado
            }
          />
        </Col>

        <Col className="mb-2" md="3">
          <TextField
            label="Comissão Calculada (%)"
            type="number"
            className="mt-2"
            value={arredondaDecimais(
              propostaVersao.valores.percentualComissao ?? 0,
            )}
            onChange={e =>
              changeValue('percentualComissao', Number(e.target.value))
            }
            disabled={
              !isModoSimulacao ||
              propostaVersao.usuario.isIsentoComissao ||
              acessoPrograma.variaveisComerciais.acessoLimitado
            }
          />
        </Col>

        <Col className="mb-2" md="3">
          <TextField
            label="Ajuste Comissão (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualAjusteComissao ?? 0}
            onChange={e =>
              changeValue('percentualAjusteComissao', Number(e.target.value))
            }
            disabled={
              !isModoSimulacao ||
              acessoPrograma.variaveisComerciais.acessoLimitado
            }
          />
        </Col>

        <Col className="mb-2" md="3">
          <TextField
            label="Comissão Calculada + Ajuste (%)"
            type="number"
            className="mt-2"
            value={arredondaDecimais(
              (propostaVersao.valores.percentualComissao ?? 0) +
                (propostaVersao.valores.percentualAjusteComissao ?? 0),
            )}
            disabled
          />
        </Col>

        <Col className="mb-2" md="3">
          <TextField
            label="Indicador de Negócio (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualIndicadorNegocio ?? 0}
            onChange={e =>
              changeValue('percentualIndicadorNegocio', Number(e.target.value))
            }
            disabled={
              !isModoSimulacao ||
              acessoPrograma.variaveisComerciais.acessoLimitado
            }
          />
        </Col>

        <Col className="mb-2" md="3">
          <TextField
            label="Comissões a Receber (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualComissaoReceber ?? 0}
            onChange={e =>
              changeValue('percentualComissaoReceber', Number(e.target.value))
            }
            disabled={
              !isModoSimulacao ||
              acessoPrograma.variaveisComerciais.acessoLimitado
            }
          />
        </Col>

        <Col
          className="mb-2"
          md="3"
          hidden={propostaVersao.variaveisComerciais.formatoMaoObra !== 'P'}
        >
          <TextField
            label="M.O / Serviços (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualServicos ?? 0}
            disabled
          />
        </Col>

        <Col className="mb-2" md="3" hidden={!propostaVersao.isExterior}>
          <TextField
            label="Valor Atual do Dólar Parametrizado (R$)"
            type="number"
            className="mt-2"
            value={parametros?.valorDolar ?? 0}
            disabled
          />
        </Col>

        <Col className="mb-2" md="3" hidden={!propostaVersao.isExterior}>
          <TextField
            label="Valor Dólar Cambial na Proposta (R$)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.valorDolar ?? 0}
            onChange={e => changeValue('valorDolar', Number(e.target.value))}
            disabled={
              !isModoSimulacao ||
              acessoPrograma.variaveisComerciais.acessoLimitado
            }
          />
        </Col>
      </Row>
    </Card>
  );
}
